<div class="calendar tp-cal-toolbar">
  <div class="tp-cal-toolbar__title">
    <h3>
      {{ title() }}
    </h3>
    @if (lastUpdate) {
      <span class="tp-cal-updated">Actualizado a las {{ lastUpdate | date : "HH:mm" }}</span>
    }
  </div>
  <div class="tp-cal-toolbar__nav">
    <button
      type="button"
      class="tp-cal-today-btn"
      mwlCalendarToday
      [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay(viewDate, view)"
      [disabled]="showsToday()"
      title="Volver a hoy"
      >
      Hoy
    </button>
    <button
      type="button"
      class="tp-cal-nav-btn"
      mwlCalendarPreviousView
      [view]="view"
      [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay(viewDate, view)"
      title="Anterior"
      aria-label="Anterior"
      >
      <img src="../../../../../assets/icons/common/back.svg" alt="" />
    </button>
    <button
      type="button"
      class="tp-cal-nav-btn"
      mwlCalendarNextView
      [view]="view"
      [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay(viewDate, view)"
      title="Siguiente"
      aria-label="Siguiente"
      >
      <img src="../../../../../assets/icons/common/next.svg" alt="" />
    </button>
    <mat-form-field appearance="outline" class="selector-view" subscriptSizing="dynamic">
      <mat-select [value]="view" (selectionChange)="setView($event.value)" aria-label="Vista del calendario">
        <mat-option [value]="CalendarView.Month">
          Mensual
        </mat-option>
        <mat-option [value]="CalendarView.Week">
          Semana
        </mat-option>
        <mat-option [value]="CalendarView.Day">
          Diario
        </mat-option>
      </mat-select>
    </mat-form-field>
    @if (!showNotScheduledTask) {
      <button type="button" class="hide-unscheduled-button" (click)="emitShowNotScheduledTask()">
        Mostrar tareas sin asignar
        <img src="../../../../../assets/icons/common/next.svg" alt="" />
      </button>
    }
  </div>
</div>

      <ng-template #customCellTemplate let-day="day" let-locale="locale">
        <div class="cal-cell-top calendar">
          <div class="tp-day-head">
            <span class="custom-cal-day-number">{{
              day.date | calendarDate : "monthViewDayNumber" : locale
            }}</span>
            @if (day.events.length > 0) {
              <span class="tp-day-count" [attr.aria-label]="day.events.length + ' tareas'">{{ day.events.length }}</span>
            }
          </div>
          @for (event of day.events; track event; let i = $index) {
            <div>
              @if (10 > i) {
                <div>
                  <app-item-template
                    [data]="event.event.data"
                    [height]="15"
                    [event]="event.event"
          [statusSelectedColor]="
            getStatusSelectedColor(event.event.data.status)
          "
                    [statusDescription]="getStatusDescription(event.event.data.status)"
                    [statusColor]="getStatusColor(event.event.data.status)"
                    [view]="view"
                    (openDialogEvent)="dialogAction('view', event)"
                  ></app-item-template>
                </div>
              }
            </div>
          }
          @if (day.events.length > 10) {
            <div class="more-events">
              <b>+ {{ day.events.length - 10 }} {{ day.events.length - 10 === 1 ? 'evento' : 'eventos' }}</b>
            </div>
          }
        </div>
      </ng-template>

      <ng-template
        #customDayWeekTemplate
        let-weekEvent="weekEvent"
        let-daysInWeek="daysInWeek"
        let-events="events"
        let-eventClicked="eventClicked"
        >
        <app-item-template
          [data]="weekEvent.event.event.data"
          [height]="weekEvent.height"
          [weekEvent]="weekEvent"
          [daysInWeek]="daysInWeek"
          [events]="events"
          [eventClicked]="eventClicked"
          [event]="weekEvent.event.event"
    [statusSelectedColor]="
      getStatusSelectedColor(weekEvent.event.event.data.status)
    "
    [statusDescription]="
      getStatusDescription(weekEvent.event.event.data.status)
    "
          [statusColor]="getStatusColor(weekEvent.event.event.data.status)"
          [view]="view"
          (openDialogEvent)="dialogAction('view', weekEvent.event)"
        ></app-item-template>
      </ng-template>

      @if (hiddenSunday(); as sunday) {
        <div class="tp-cal-sunday-notice" role="status">
          <span>Hay tareas el domingo {{ sunday | date : "d/M" }}, que no se muestra en esta pantalla.</span>
          <button type="button" class="tp-cal-today-btn" (click)="showSunday(sunday)">Ver en vista diaria</button>
        </div>
      }

      <div class="tp-cal-scroll" [class.tp-cal-scroll--month]="view === CalendarView.Month">
        @switch (view) {
          @case (CalendarView.Month) {
            <mwl-calendar-month-view
              [viewDate]="viewDate"
              [events]="events"
              [excludeDays]="excludeDays()"
              [refresh]="refresh"
              [activeDayIsOpen]="activeDayIsOpen"
              [cellTemplate]="customCellTemplate"
              (dayClicked)="openListDialogAction($event)"
              >
            </mwl-calendar-month-view>
          }
          @case (CalendarView.Week) {
            <mwl-calendar-week-view
              [viewDate]="viewDate"
              [events]="events"
              [excludeDays]="excludeDays()"
              [refresh]="refresh"
              [eventTemplate]="customDayWeekTemplate"
              >
            </mwl-calendar-week-view>
          }
          @case (CalendarView.Day) {
            <mwl-calendar-day-view
              [viewDate]="viewDate"
              [events]="events"
              [refresh]="refresh"
              [eventTemplate]="customDayWeekTemplate"
              >
            </mwl-calendar-day-view>
          }
        }
      </div>
